<template>
  <section class="text-pdsPrimaryColor">
    <div class="grid grid-rows">
      <h1 class="py-4 px-6 font-bold text-xl flex text-pdsPrimaryColor bg-balternative-color my-0">Contact</h1>
      <div class="grid grid-rows gap-2 p-6">
        <div class="mb-4">Openingstijden: Ma. t/m Vr. 08:30 - 17:00</div>
        <div class="grid grid-rows lg:grid-cols-4 gap-4 mb-4">
          <div>
            <div>Contintiezorg</div>
            <div>088 888 94 01</div>
          </div>
          <div>
            <div>Infuustherapie</div>
            <div>088 888 94 80</div>
          </div>
          <div>
            <div>OSA-therapie</div>
            <div>088 888 94 81</div>
          </div>
          <div>
            <div>Medische voeding</div>
            <div>088 888 94 07</div>
          </div>
          <div>
            <div>Wondzorg</div>
            <div>088 888 94 00</div>
          </div>
          <div>
            <div>Slaaponderzoek</div>
            <div>088 888 94 81</div>
          </div>
          <div>
            <div>Stomazorg</div>
            <div>088 888 94 02</div>
          </div>
          <div>
            <div>Verneveling</div>
            <div>088 888 94 82</div>
          </div>
          <div>
            <div>Slijmuitzuiging en monitoring</div>
            <div>088 888 94 82</div>
          </div>
          <div>
            <div>Servicedesk Professionals Diabetes</div>
            <div>088 888 94 06</div>
          </div>
        </div>
        <div class="mb-2">
          <div>
            <span class="font-bold">Let op: </span>de volgende informatie is uitsluitend bestemd voor huisartsen.
          </div>
          <div>
            Wij zijn maandag t/m vrijdag van 08.30 uur tot 17.30 uur bereikbaar via: 088-888 94 05. Dit telefoonnummer
            is uitsluitend voor zorgprofessionals. Bij nood- of spoedgevallen wordt u buiten deze tijden direct
            doorgeschakeld naar onze noodlijn.
          </div>
        </div>
        <div>Het telefoonnummer waar uw patiënten Mediq op kunnen bereiken is: 088-888 94 50.</div>
      </div>
    </div>
  </section>
</template>
